import tippy from 'tippy.js'

export default function initCardTooltip () {
  tippy('.show-tooltip', {
    content: ' Unclaimed '
  })
}
